export default function SmallCheckIconStepper() {
  return (
    <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 5.44444L4.58042 9L12.6364 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
  )
}
